import React from "react";
import "./Main.css";
import Logo from "./Components/Logo";
import ApplicationButton from "./Components/ApplicationButton";
import MentorGallery from "./Components/MentorGallery";

const Main: React.FC = () => {
    return (
        <div className="main-container">
            <div className="logo-container">
                <Logo />
            </div>

            {/* TAGLINE */}
            <img
                src="logos/Bu1dl-3-Words-Banner.png"
                className="tagline-banner"
                alt="banner"
            />

            {/* SHORT BLURB */}
            <div className="description-container">
                <div className="description-words">
                    <p>
                        BU1DL empowers dreamers, innovators, and builders to
                        become a driving force shaping the future of tech. Take
                        your ideas from 0 to 1 and create your own
                        opportunities. Ignite your <b>spark of inspiration</b>{" "}
                        and fuel others to keep the fire alive.
                    </p>
                </div>
            </div>

            {/* APPLICATION BUTTON */}
            <ApplicationButton
                href="https://forms.gle/ZVPE834LCKL4Vsw29" //"https://forms.gle/kE7q1k5ZFQTq7ZNPA" <- participant applications
                label="BUILDER APPLICATIONS CLOSED!!!" //Change to "APPLICATIONS OPEN" for participants
            />

            {/* MENTOR GALLERY */}
            <MentorGallery />

            {/* DESCRIPTION */}
            <div className="logistics-container">
                <div className="logistics-words">
                    <h4>Is this meant for you?</h4>
                    <p>
                        <h5>BU1DL is 100% builder-driven.</h5>
                        Over a 4-month journey, builders are matched in groups
                        of 2-4 and paired up with 1-2 designated mentors with
                        direct project building experience. Each builder must
                        have an idea (or the beginning stages of a
                        work-in-progress) and most importantly... the drive to
                        innovate and BUILD. The ultimate goal? To ship a
                        finished project within the 4-month timeframe or reach
                        an MVP with significant progress. Throughout your
                        journey, builders will have access to support and
                        monthly check-ins with their mentors to keep momentum
                        and track progress.
                        <h5>
                            If you’re ready to inspire others, innovate, commit,
                            and leave with something you can show the world...
                            You’re exactly who BU1DL was built for.
                        </h5>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Main;
